import { t } from '../../i18n/index.js';
import { CouponGrid } from '../../bingo/ui.js';
import { ballLabel, neededForStage, type BingoHostState } from '../../../shared/bingo.js';

// The coupons near a bingo as pictures for the host (user request 2026-10-01): the drawn numbers
// marked and the numbers still needed highlighted, closest first – the order follows the draw.
// Shown in both the hosted and the automatic game.

const MAX_SHOWN = 18;

export function NearCoupons(props: { host: BingoHostState }) {
  const game = props.host.game!;
  const drawn = new Set(game.draws);
  const list = [...props.host.bingo, ...props.host.near].sort((a, b) => a.missing - b.missing || a.cardNumber - b.cardNumber);
  const n = t.admin.bingo;
  return (
    <div class="bingo-panel">
      <h3>{n.nearTitle}</h3>
      {list.length === 0 ? (
        <p class="muted">{n.nearNone}</p>
      ) : (
        <>
          <div class="near-coupons">
            {list.slice(0, MAX_SHOWN).map((x) => {
              const needed = neededForStage(x.cells, drawn, game.stage);
              return (
                <div class={`near-coupon near-${x.missing}`} key={x.cardNumber}>
                  <div class="near-coupon-head">
                    <b>{n.cardLabel(x.cardNumber, x.nickname)}</b>
                    <span class="badge">{x.missing === 0 ? 'BINGO' : n.missing(x.missing)}</span>
                  </div>
                  <CouponGrid cells={x.cells} marked={drawn} needed={new Set(needed)} class="mini" />
                  {needed.length > 0 && <div class="near-coupon-needs">{n.needs(needed.map(ballLabel).join(', '))}</div>}
                </div>
              );
            })}
          </div>
          {list.length > MAX_SHOWN && <p class="muted">{n.nearMore(list.length - MAX_SHOWN)}</p>}
        </>
      )}
    </div>
  );
}
